import Base from './Base';
import React from 'react';
import { PostBody } from 'js/social/News/Body';
import styled from 'astroturf/react';
import { Button } from 'js/social/shared/design_system/Button';

const RemovedNoticeBase = styled(Base)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #222233;
  padding-top: 10px;
`;

const RemovedPostBody = styled(PostBody)`
  color: #535366;
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface RemovedItemNoticeProps {
  undoRemoval: () => void;
}

export const RemovedItemNotice = ({
  undoRemoval,
}: RemovedItemNoticeProps): JSX.Element => {
  return (
    <RemovedNoticeBase
      header={''}
      content={
        <ContentContainer>
          <div>
            <strong>Thanks for your feedback</strong>
            <RemovedPostBody
              content={'You won’t see this post in your feed again.'}
            />
          </div>
          <Button onClick={undoRemoval} variant={'text'}>
            Undo
          </Button>
        </ContentContainer>
      }
    />
  );
};
